<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.faqs')"
                :pgIcon="'bx bx-comment'"
                :refs="refs"
                :addNew="addNew">
            </Breadcrumb>


            <DataTable
                :refs="refs"
                :colspan=9

                :hasSearchFilter=true
                :hasDateFilter=true
                :hasStatusApproved=true
                :hasStatusFilter=true
                :hasLecturerFilter=true

                :hasHashId=true
                :hasMultiSelect=false
                :hasBulkAction=false
                :HasExport=true
                :hasShowEntries=true

                :lblSearch="$t('app.search_by_name')"

                :fields="{
                    'id': 'id',
                    'username': 'username',
                    'price': 'price',
                    'question': 'question',
                    'answerd': 'answerd',
                    'paid': 'paid',
                    'status': 'status'
                }"

                :hasUser=true
                :image="$t('view.user')"
                :image_style="'width: 40px;height: 40px;border-radius: 50%'"

                :price="$t('app.price')"

                :hasQuestion=true
                :hasPrice=true
                :hasDate=true
                :hasPaid=true
                :hasStatus=true
                :hasNoEdit=true
                :hasAccept=true
                :hasDecline=true
                :hasApproved=true
                :hasActions=true
                :hasNoDelete=true
                :hasShow=true

                :actionable=true
                :sorDataTable=true

                v-on:hasAddNewPermission="handlePermissoinChange">
            </DataTable>

        </div>
    </div>

</template>

<script>
export default {
    name: 'List',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        DataTable: () => import('@/components/DataTable.vue')
    },
    data(){
        return {    
            //
            addNew: false,
            refs: 'faqs',
        }
    },
    watch: {
        //
    },
    mounted() {
        //
    },
    created() {
        //
    },
    methods: {
        handlePermissoinChange(event) {
            //this.addNew = event;
            console.log(event)
        },
    },
}
</script>
